import styled from '@emotion/styled/macro';

export const StyledLoadingContainer = styled.div`
  display: grid;
  place-content: center;
  width: 100%;
  height: 100%;
`;
